<div [class.isDetailRoute]="isDetailRoute" class="navbar-mobile">
  <button
    class="text-btn-16"
    (click)="toggleCollapse()"
    nz-button
    nzShape="circle"
    nzType="default"
  >
    <app-st-icon name="menu"></app-st-icon>
  </button>

  <h1 class="text-header-24">{{ currentRouteLabel }}</h1>
</div>

<div *ngIf="!isCollapsed" (click)="toggleCollapse()" class="shadow-bg">
  <button nz-button nzType="primary" nzShape="circle">
    <app-st-icon name="close"></app-st-icon>
  </button>
</div>

<nz-sider
  nzCollapsible
  [(nzCollapsed)]="isCollapsed"
  [nzTrigger]="null"
  [nzCollapsedWidth]="(isMobile$ | async) ? 0 : 64"
  style="padding: 16px 8px"
>
  <!-- Logo -->
  <div class="logo" (click)="toggleCollapse()">
    <span class="text-header-24" *ngIf="!isCollapsed">CRM</span>
    <app-st-icon
      *ngIf="!(isMobile$ | async)"
      [name]="!isCollapsed ? 'left_panel_close' : 'right_panel_close'"
    ></app-st-icon>
  </div>
  <!-- Sociedades -->
  <div
    nz-dropdown
    [nzTrigger]="'click'"
    [nzOverlayStyle]="{ minWidth: '260px' }"
    [nzOverlayClassName]="isCollapsed ? 'company-dropdown-overlay company-dropdown-overlay-collapsed' : 'company-dropdown-overlay company-dropdown-overlay-expanded'"
    [nzClickHide]="false"
    [nzDropdownMenu]="menu"
    nzPlacement="bottomRight"
    [nzVisible]="companyDropdownVisible"
    (nzVisibleChange)="onCompanyDropdownVisibleChange($event)"
  >
    <div class="company-selector">
      <nz-avatar [nzText]="selectedCompanyInitials"></nz-avatar>
      @if (!isCollapsed) {
      <span>{{ selectedCompany?.name }}</span>
      <app-st-icon name="keyboard_arrow_down"></app-st-icon>
      }
    </div>
  </div>
  <!-- Dropdown Menu -->
  <nz-dropdown-menu #menu="nzDropdownMenu">
    <ul nz-menu class="company-dropdown-menu">
      <li
        nz-menu-item
        *ngFor="let company of loggedUser?.companies"
        [class.selected]="isOperatingCompany(company)"
        (click)="setOperatingCompany(company, $event)"
        class="company-menu-item"
      >
        <div class="company-menu-content">
          <label
            nz-checkbox
            [nzChecked]="isCompanySelected(company)"
            [nzDisabled]="isCompanySelectionLocked(company)"
            (click)="$event.stopPropagation()"
            (nzCheckedChange)="toggleCompanySelection(company)"
            class="company-menu-label"
          >
          </label>
          <span class="company-menu-name">
            {{ company.name }}
          </span>
          <span class="company-active-icon" *ngIf="isOperatingCompany(company)">
            <app-st-icon
              name="bookmark"
              [bold]="true"
              [filled]="true"
            ></app-st-icon>
          </span>
        </div>
      </li>
      <li class="company-menu-actions">
        <button
          nz-button
          nzType="default"
          nzSize="small"
          nzShape="round"
          [disabled]="!hasPendingCompanyChanges()"
          (click)="resetPendingCompanySelection(); $event.stopPropagation()"
        >
          Restablecer
        </button>
        <button
          nz-button
          nzType="primary"
          nzSize="small"
          nzShape="round"
          [disabled]="!hasPendingCompanyChanges()"
          (click)="confirmCompanySelection(); $event.stopPropagation()"
        >
          Confirmar
        </button>
      </li>
    </ul>
  </nz-dropdown-menu>
  <!-- Menú principal -->
  <ul
    nz-menu
    nzMode="inline"
    style="margin-bottom: 70px"
    [nzInlineCollapsed]="isCollapsed"
  >
    @for (item of menuItems; track item) { @if (item.icon) {
    <li
      *ngIf="loggedUser?.viewAdministracion || item.label !== 'Administración'"
      [nz-tooltip]="isCollapsed ? item.label : null"
      nzTooltipPlacement="right"
      nz-menu-item
      [routerLink]="['/' + item.route]"
      routerLinkActive="ant-menu-item-selected"
      [routerLinkActiveOptions]="{
        paths: 'exact',
        queryParams: 'ignored',
        fragment: 'ignored',
        matrixParams: 'ignored'
      }"
    >
      <!--          [nzColor]="'#0068D6'"-->
      <div style="display: flex">
        @if (item.label === 'Notificaciones' && isCollapsed){
        <nz-badge
          [nzDot]="inboxNotification > 0"
          [nzOffset]="[1, 9]"
          [nzStyle]="{ backgroundColor: 'red' }"
        >
          <app-st-icon [color]="item.color" [name]="item.icon"></app-st-icon>
        </nz-badge>
        }@else{<app-st-icon
          [color]="item.color"
          [name]="item.icon"
        ></app-st-icon
        >}
        <span *ngIf="!isCollapsed" style="flex-grow: 1">{{ item.label }}</span>
        <!-- Badge para menú expandido -->
        @if (item.label === 'Notificaciones' && !isCollapsed &&
        inboxNotification > 0) {
        <nz-badge
          nzStandalone
          [nzStyle]="{
            backgroundColor: '#EBF5FF',
            color: '#0068D6',
            fontSize: '10px',
            fontWeight: '600'
          }"
          [nzCount]="inboxNotification"
          style="margin: auto"
        ></nz-badge>
        }
      </div>
    </li>
    } }

    <!-- Menú de Maestros - Versión colapsada (Dropdown) -->
    <ng-container>
      <li
        *ngIf="
          loggedUser?.viewMaestros ||
          loggedUser?.viewOnlyDriversEquipmentsMaestros
        "
        nz-dropdown
        [nzTrigger]="'click'"
        [nzOverlayStyle]="{ minWidth: '200px' }"
        [nzClickHide]="true"
        [nzDropdownMenu]="maestrosMenu"
        nzPlacement="topRight"
        [nz-tooltip]="isCollapsed ? 'Maestros' : null"
        nzTooltipPlacement="right"
        class="ant-menu-item maestros-dropdown"
      >
        <div class="maestros-selector">
          <app-st-icon
            [color]="'#067A6E'"
            [name]="'auto_stories'"
          ></app-st-icon>
          @if (!isCollapsed) {
            <span>Maestros</span>
          }
        </div>
      </li>
      <nz-dropdown-menu #maestrosMenu="nzDropdownMenu">
        <ul
          nz-menu
          [style.left]="'25%'"
          [style.bottom]="'5%'"
          class="custom-dropdown-scroll"
        >
          @for(group of groupedMaestrosSubmenuItems; track $index){ @for (item
          of group; track item) { @if (loggedUser?.viewMaestros ||
          (loggedUser?.viewOnlyDriversEquipmentsMaestros && (item.label ===
          'Conductores' || item.label === 'Equipos'))) {
          <li
            nz-menu-item
            [routerLink]="['/maestro/' + item.route]"
            routerLinkActive="ant-menu-item-selected"
            [routerLinkActiveOptions]="{
              paths: 'exact',
              queryParams: 'ignored',
              fragment: 'ignored',
              matrixParams: 'ignored'
            }"
            class="maestro-dropdown"
          >
            <span>{{ item.label }}</span>
          </li>
          } } @if (!$last && loggedUser?.viewMaestros){
          <li nz-menu-divider [style.margin]="'12px 0px'"></li>
          } }
        </ul>
      </nz-dropdown-menu>
    </ng-container>
  </ul>
  <!-- Elementos adicionales abajo -->
  <div class="sidebar-footer">
    <div
      nz-dropdown
      [nzTrigger]="'click'"
      [nzDropdownMenu]="userMenu"
      class="user-info"
      nzPlacement="topRight"
    >
      <nz-avatar
        class="not-max-width"
        [nzSrc]="loggedUser?.partner?.avatar ? getSafeImageUrl(loggedUser?.partner?.avatar) : undefined"
        [nzText]="!loggedUser?.partner?.avatar ? loggedUserInitials : undefined"
        [style.backgroundColor]="!loggedUser?.partner?.avatar ? '#ffffff' : undefined"
        [style.color]="!loggedUser?.partner?.avatar ? '#000000' : undefined"
        [style.border]="!loggedUser?.partner?.avatar ? '1px solid #d9d9d9' : undefined"
        [style.fontWeight]="!loggedUser?.partner?.avatar ? '600' : undefined"
      ></nz-avatar>
      <div *ngIf="!isCollapsed">
        <strong
          >{{ loggedUser?.partner?.name }}
          {{ loggedUser?.partner?.surName }}</strong
        >
        <span>{{ loggedUser?.partner?.position }}</span>
      </div>
    </div>

    <!-- Menú desplegable para Estados -->
    <nz-dropdown-menu #userMenu="nzDropdownMenu">
      <ul
        [style.left]="(isMobile$ | async) ? '0' : isCollapsed ? '25%' : '100%'"
        [style.top]="isCollapsed ? '30%' : '0'"
        nz-menu
      >
        <li nz-menu-item (click)="logout()">
          <app-st-icon [bold]="true" name="logout"></app-st-icon>
          Cerrar sesión
        </li>
      </ul>
    </nz-dropdown-menu>
    <!--    <ul nz-menu>-->
    <!--      <li class="settings" [routerLink]="'/configuration'" routerLinkActive="ant-menu-item-selected">-->
    <!--        <app-st-icon name="settings"></app-st-icon>-->
    <!--        <span *ngIf="!isCollapsed">Configuración</span>-->
    <!--      </li>-->
    <!--    </ul>-->
  </div>
</nz-sider>
